export enum TipoPartoEnum {
    NORMAL = 1,
    AUXILIADO = 2,
    ABORTO_COM_LACTACAO = 3,
    PREMATURO = 4
}
